module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-10-12e0ae5c71cad12c788b52aa7477db45.webp";